import { render, staticRenderFns } from "./ModalVersion.vue?vue&type=template&id=aabda022&"
import script from "./ModalVersion.vue?vue&type=script&lang=ts&"
export * from "./ModalVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports